export const current_team_photo = [
  {
    "id": 34,
    "type": "executive_committee",
    "src": "/photos/members25-26/Pranav Vasishta G.jpg",
    "name": "Pranav Vasishta G",
    "post": "CHAIRPERSON",
    "linkedin": "Nil",
    "gmail": "pranav2013g@gmail.com"
  },
  {
    "id": 38,
    "type": "executive_committee",
    "src": "/photos/members25-26/Kiran Ramdurg.png",
    "name": "Kiran Ramdurg",
    "post": "VICE CHAIRPERSON",
    "linkedin": "https://www.linkedin.com/in/kiran-ramdurg-85306617a",
    "gmail": "kiranramdurg17@gmail.com"
  },
  {
    "id": 21,
    "type": "executive_committee",
    "src": "/photos/members25-26/Chethana J.jpg",
    "name": "Chethana J",
    "post": "GENERAL SECRETARY",
    "linkedin": "https://www.linkedin.com/in/chethana-j-14889825a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "gmail": "chethanaj05@gmail.com"
  },
  {
    "id": 28,
    "type": "executive_committee",
    "src": "/photos/members25-26/Charan S.jpg",
    "name": "Charan S",
    "post": "PUBLICITY LEAD",
    "linkedin": "https://www.linkedin.com/in/charan-s-391640256",
    "gmail": "cs8539929@gmail.com"
  },
  {
    "id": 8,
    "type": "executive_committee",
    "src": "/photos/members25-26/Kushwanth_S.jpg",
    "name": "Kushwanth S",
    "post": "SAC CO-ORDINATOR",
    "linkedin": "linkedin.com/in/kushwanth-s-profile/",
    "gmail": "kushwanthsuresh8@gmail.com"
  },
  {
    "id": 31,
    "type": "executive_committee",
    "src": "/photos/members25-26/Suraj V.jpg",
    "name": "Suraj V",
    "post": "SAC CO-ORDINATOR",
    "linkedin": "https://www.linkedin.com/in/suraj-v-32a604258?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "gmail": "surajvviswanathad@gmail.com"
  },
  {
    "id": 30,
    "type": "executive_committee",
    "src": "/photos/members25-26/Ananya Ramesha.jpg",
    "name": "Ananya R",
    "post": "EVENT MANAGER",
    "linkedin": "https://www.linkedin.com/in/ananya-r-1591b9312/",
    "gmail": "ananyaramesh054@gmail.com"
  },
  {
    id: 19,
    type: 'executive_committee',
    src: '/photos/members/IMG_20230618_172711_035 - Meghana K S.jpg',
    name: 'Yashaswini K S',
    post: 'REPORTING LEAD',
    linkedin: 'https://www.linkedin.com/in/yashaswini-ks-615975309?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'yashaswini.ks32@gmail.com',
  },
  {
    "id": 25,
    "type": "executive_committee",
    "src": "/photos/members25-26/Rachit Jain.jpg",
    "name": "Rachit Jain",
    "post": "JOINT SECRETARY",
    "linkedin": "https://in.linkedin.com/in/rachit-jain-b91a90364",
    "gmail": "nprachit84@gmail.com"
  },
  {
    "id": 25,
    "type": "executive_committee",
    "src": "/photos/members25-26/Ankith Kaushik.jpeg",
    "name": "Ankith Kaushik",
    "post": "TREASURER",
    "linkedin": "https://www.linkedin.com/in/ankith-kaushik-222339328",
    "gmail": "ankithkaushik2005@gmail.com"
  },
  {
    "id": 11,
    "type": "executive_committee",
    "src": "/photos/members25-26/WhatsApp Image 2026-02-26 at 13.49.22.jpeg",
    "name": "Keerthana R Nair",
    "post": "CHIEF STUDENT CO-ORDINATOR",
    "linkedin": "https://www.linkedin.com/in/keerthana-r-nair-304b8a2aa?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "gmail": "Keerthanarn05@gmail.com"
  },
  {
    "id": 9,
    "type": "executive_committee",
    "src": "/photos/members25-26/DhanalakshmiRP.jpg",
    "name": "Dhanalakshmi R Pagade",
    "post": "PUBLICITY CO-ORDINATOR",
    "linkedin": "https://www.linkedin.com/in/dhanalakshmi-rl-pagade-129488292?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "gmail": "dhanalakshmirpagade@gmail.com"
  },
   {
    "id": 51,
    "type": "executive_committee",
    "src": "/photos/members25-26/Apoorva H N.jpg",
    "name": "Apoorva H N",
    "post": "PUBLICITY CO-ORDINATOR",
    "linkedin": "https://www.linkedin.com/in/apoorva-h-n-9b7b542b1?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "gmail": "hmapoorvahn@gmail.com"
  },
  {
    "id": 32,
    "type": "executive_committee",
    "src": "/photos/members25-26/arjun.jpeg",
    "name": "Arjun A Bharadwaj",
    "post": "STUDENT CO-ORDINATOR",
    "linkedin": "https://www.linkedin.com/in/arjun-a-bharadwaj-8a9487292?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "gmail": "arjun.bharadwaj2005@gmail.com"
  },
  
  {
    "id": 40,
    "type": "executive_committee",
    "src": "/photos/members25-26/Pallavi S.jpg",
    "name": "Pallavi S",
    "post": "STUDENT CO-ORDINATOR",
    "linkedin": "https://www.linkedin.com/in/pallavis21",
    "gmail": "pallavis2125@gmail.com"
  },
  {
    "id": 2,
    "type": "executive_committee",
    "src": "/photos/members25-26/Alvisha.jpg",
    "name": "Alvisha Florine Veigas",
    "post": "REPORTER",
    "linkedin": "https://linkedin.com/in/alvishaflorineveigas2805",
    "gmail": "alvishaveigas@gmail.com"
  },
  {
    "id": 5,
    "type": "executive_committee",
    "src": "/photos/members25-26/vruddhi.jpg",
    "name": "Vruddhi Dinesh",
    "post": "REPORTER",
    "linkedin": "https://www.linkedin.com/in/vruddhi-dinesh-085867282",
    "gmail": "vruddhidinesh@gmail.com"
  },
  {
    "id": 6,
    "type": "signal_processing_society",
    "src": "/photos/members25-26/DEEKSHITH R.jpg",
    "name": "Deekshith R",
    "post": "CHAIRPERSON",
    "linkedin": "https://www.linkedin.com/in/deekshith-r-51b545258",
    "gmail": "deekshithr2204@gmail.com"
  },
  {
    "id": 7,
    "type": "signal_processing_society",
    "src": "/photos/members25-26/Rahul Murali.jpg",
    "name": "Rahul Murali",
    "post": "SECRETARY",
    "linkedin": "https://www.linkedin.com/in/rahul-murali-405677335?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "gmail": "muralirahul6210@gmail.com"
  },
  {
    "id": 26,
    "type": "signal_processing_society",
    "src": "/photos/members25-26/Shravan Krishna.jpg",
    "name": "Shravan Krishna",
    "post": "JOINT SECRETARY",
    "linkedin": "https://www.linkedin.com/in/shravan-krishna-0a4486292?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "gmail": "shravankrishna2018@gmail.com"
  },
  {
    "id": 1,
    "type": "signal_processing_society",
    "src": "/photos/members25-26/Muskan fayaz.jpg",
    "name": "Muskan",
    "post": "TECHNICAL CO-ORDINATOR",
    "linkedin": "https://www.linkedin.com/in/muskan-fayaz-52757b306",
    "gmail": "muskanfayaz48@outlook.com"
  },
  {
    "id": 18,
    "type": "robotics_and_automation_society",
    "src": "/photos/members25-26/Nandeesh.S.U.jpg",
    "name": "Nandeesh S U",
    "post": "CHAIRPERSON",
    "linkedin": "https://www.linkedin.com/in/nandeesh-s-u",
    "gmail": "nandeeshsu2003@gmail.com"
  },
   {
    "id": 41,
    "type": "robotics_and_automation_society",
    "src": "/photos/members25-26/Adnan Hussain.jpg",
    "name": "Adnan Hussain Sarkar",
    "post": "VICE CHAIRPERSON",
    "linkedin": "https://www.linkedin.com/in/adnan-hussain-sarkar-4846b11bb",
    "gmail": "adnanhsarkar16@gmail.com"
  },
  {
    "id": 39,
    "type": "robotics_and_automation_society",
    "src": "/photos/members25-26/Akshay.JPG",
    "name": "Akshay Kumar",
    "post": "SENIOR TECHNICAL CO-ORDINATOR",
    "linkedin": "https://www.linkedin.com/in/akshay-kumar-9484592a1",
    "gmail": "akshayyk210@gmail.com"
  },
  {
    "id": 29,
    "type": "robotics_and_automation_society",
    "src": "/photos/members25-26/Prithveesh Rao.jpeg",
    "name": "Prithveesh Rao",
    "post": "SECRETARY",
    "linkedin": "https://www.linkedin.com/in/prithveesh-rao-4345521a1?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "gmail": "raoprithveesh@gmail.com"
  },
  {
    "id": 3,
    "type": "robotics_and_automation_society",
    "src": "/photos/members25-26/Chinmay GC.jpg",
    "name": "Chinmay G C",
    "post": "JOINT SECRETARY",
    "linkedin": "https://www.linkedin.com/in/chinmay-gc",
    "gmail": "chinmaygchandramouli@gmail.com"
  },
  
  {
    "id": 24,
    "type": "robotics_and_automation_society",
    "src": "/photos/members25-26/Rohan A S Gowda.jpg",
    "name": "Rohan A S Gowda",
    "post": "TECHNICAL CO-ORDINATOR",
    "linkedin": "https://www.linkedin.com/in/rohan-a-s-gowda-b27580292?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "gmail": "rohanasgowda7411@gmail.com"
  },
  
 
  {
    "id": 27,
    "type": "electron_devices_society",
    "src": "/photos/members25-26/Gagan Deep.jpg",
    "name": "Gagan Deep P S",
    "post": "CHAIRPERSON",
    "linkedin": "http://linkedin.com/in/gagan-deep-71826a261",
    "gmail": "psgagan361@gmail.com"
  },
  {
    "id": 23,
    "type": "electron_devices_society",
    "src": "/photos/members25-26/Supreeth Prasad.jpg",
    "name": "SUPREETH PRASAD",
    "post": "VICE CHAIRPERSON",
    "linkedin": "https://www.linkedin.com/in/supreeth964prasad",
    "gmail": "supreethp90@gmail.com"
  },
  {
    "id": 36,
    "type": "electron_devices_society",
    "src": "/photos/members25-26/Lumbini A Tambat.jpg",
    "name": "Lumbini A Tambat",
    "post": "SENIOR TECHNICAL CO-ORDINATOR",
    "linkedin": "https://www.linkedin.com/in/lumbini-ashutosh-tambat-a83878309?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "gmail": "lumbiniatambat@gmail.com"
  },
  {
    "id": 4,
    "type": "electron_devices_society",
    "src": "/photos/members25-26/Pramathi H.B.jpg",
    "name": "Pramathi H.B",
    "post": "SECRETARY",
    "linkedin": "https://www.linkedin.com/in/pramathi-h-b-808487292",
    "gmail": "pramathi1805@gmail.com"
  },
  {
    "id": 19,
    "type": "electron_devices_society",
    "src": "/photos/members25-26/harshith ar.JPG",
    "name": "Harshith A R",
    "post": "JOINT SECRETARY",
    "linkedin": "https://www.linkedin.com/in/harshi76",
    "gmail": "arharshi9535@gmail.com"
  },
  {
    "id": 33,
    "type": "electron_devices_society",
    "src": "/photos/members25-26/Sachin K.S.jpg",
    "name": "Sachin K S",
    "post": "TECHNICAL CO-ORDINATOR",
    "linkedin": "https://www.linkedin.com/in/sachinks21",
    "gmail": "kssachin42@gmail.com"
  },
  {
    "id": 35,
    "type": "women_in_engineering",
    "src": "/photos/members25-26/Lalithya Govardhan.png",
    "name": "Lalithya Govardhan",
    "post": "CHAIRPERSON",
    "linkedin": "https://www.linkedin.com/in/lalithya-govardhan-a05363341?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "gmail": "lalithyag0224@gmail.com"
  },
  {
    id: 50,
    type: 'women_in_engineering',
    src: '/photos/members/Bharath photo - Bharatheshwar M.jpeg',
    name: 'Bharatheshwar M',
    post: 'VICE CHAIRPERSON',
    linkedin:
      'http://www.linkedin.com/in/bharatheshwar-m-9323b9187',
    gmail: 'bharatheshwar31m@gmail.com',
  },
  {
    id: 51,
    type: 'women_in_engineering',
    src: '/photos/members/WhatsApp Image 2025-03-24 at 15.07.55_00514846 - Thanmayee A.jpg',
    name: 'Thanmayee A',
    post: 'SENIOR TECHNICAL CO-ORDINATOR',
    linkedin:
      'http://www.linkedin.com/in/thanmayee1213',
    gmail: 'thanmayeea.13@gmail.com',
  },
  {
    id: 52,
    type: 'women_in_engineering',
    src: '',
    name: 'Pragathi P',
    post: 'EVENT CO-ORDINATOR',
    linkedin:
      '',
    gmail: '',
  },
  {
    "id": 12,
    "type": "women_in_engineering",
    "src": "/photos/members25-26/Anagha V Bhat.jpeg",
    "name": "Anagha V Bhat",
    "post": "SECRETARY",
    "linkedin": "http://linkedin.com/in/anagha-v-bhat-012195361",
    "gmail": "anaghavbhat13@gmail.com"
  },
  {
    "id": 12,
    "type": "women_in_engineering",
    "src": "/photos/members25-26/Pratham MS.jpeg",
    "name": "Pratham M S",
    "post": "JOINT SECRETARY",
    "linkedin": "http://www.linkedin.com/in/pratham-ms-1312i",
    "gmail": "prathamms01@gmail.com"
  },
  {
    "id": 16,
    "type": "women_in_engineering",
    "src": "/photos/members25-26/DhanyaBGowda.jpg",
    "name": "Dhanya B",
    "post": "TECHNICAL CO-ORDINATOR",
    "linkedin": "https://www.linkedin.com/in/dhanya-b-146755360",
    "gmail": "iamdhanyab2525@gmail.com"
  },
  {
    id: 48,
    type: 'editorial_board',
    src: '/photos/members/IMG_5835 - Skanda sai Keshav.jpeg',
    name: 'Keshav Skanda Sai',
    post: 'CHAIRPERSON',
    linkedin: 'https://www.linkedin.com/in/skanda-sai-keshav-814a35258/overlay/about-this-profile/?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base%3BqG2endZmSYKExvezg1mQdQ%3D%3D',
    gmail: 'niknis81@gmail.com',
  },

  {
    "id": 20,
    "type": "editorial_board",
    "src": "/photos/members25-26/Manya Basappa.jpg",
    "name": "Manya G Basappa",
    "post": "SENIOR EDITOR",
    "linkedin": "www.linkedin.com/in/manyagbasappa",
    "gmail": "manyagbasappa@gmail.com"
  },
  {
    id: 49,
    type: 'editorial_board',
    src: '/photos/members/profile - Varadaraj g.jpg',
    name: 'Varada Raj G',
    post: 'SENIOR EDITOR',
    linkedin:
      'http://www.linkedin.com/in/varadaraj-g-821b30257',
    gmail: 'varadarajug51@gmail.com',
  },
  {
    "id": 10,
    "type": "editorial_board",
    "src": "/photos/members25-26/LikhithaSA.webp",
    "name": "Likhitha S A",
    "post": "EDITOR",
    "linkedin": "https://www.linkedin.com/in/likhitha-s-a-1b90652a2?utm_source=share_via&utm_content=profile&utm_medium=member_android",
    "gmail": "likhithasasa@gmail.com"
  },
  {
    "id": 47,
    "type": "editorial_board",
    "src": "/photos/members25-26/Sushma.jpg",
    "name": "Sushma M",
    "post": "EDITOR",
    "linkedin": "https://www.linkedin.com/in/sushma-m-429034339?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "gmail": "sushs0305@gmail.com"
  },
  {
    "id": 13,
    "type": "editorial_board",
    "src": "/photos/members25-26/Shalini.jpeg",
    "name": "Shalini H R",
    "post": "GRAPHIC DESIGNER",
    "linkedin": "www.linkedin.com/in/shalini-h-r-15092005shr",
    "gmail": "shalinihr2005@gmail.com"
  },
  {
    "id": 14,
    "type": "editorial_board",
    "src": "/photos/members25-26/Mythri G.jpg",
    "name": "Mythri G",
    "post": "GRAPHIC DESIGNER",
    "linkedin": "https://www.linkedin.com/in/mythri-g-285546330",
    "gmail": "mythrig2005@gmail.com"
  },
  {
    id: 49,
    type: 'membership_development_committee',
    src: '/photos/members/WhatsApp Image 2025-03-24 at 16.30.21_7c4fb8b1 - Sushanth Doggalli O.jpg',
    name: 'Sushanth Doggalli O',
    post: 'CHAIRPERSON',
    linkedin: 'https://www.linkedin.com/in/sushanth-d-o-2a0980309?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'sushanthdoggalli@gmail.com',
  },
{
    "id": 17,
    "type": "membership_development_committee",
    "src": "/photos/members25-26/Chintan Shanbhog.jpg",
    "name": "Chintan C Shanbhog",
    "post": "VICE CHAIRPERSON",
    "linkedin": "https://www.linkedin.com/in/chintan-c-shanbhog-3bb95b309?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "gmail": "chintanshanbhog07@gmail.com"
  },
  {
    "id": 15,
    "type": "membership_development_committee",
    "src": "/photos/members25-26/Varsha Lakshmi K.jpg",
    "name": "Varsha Lakshmi K",
    "post": "SECRETARY",
    "linkedin": "https://www.linkedin.com/in/varsha-lakshmi-k-7159b22ab?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    "gmail": "varshalakshmik@gmail.com"
  },
  {
    "id": 17,
    "type": "membership_development_committee",
    "src": "/photos/members25-26/Sukruthi Rao.jpg",
    "name": "Sukruthi Rao",
    "post": "SBMDC AMBASSADOR",
    "linkedin": "https://www.linkedin.com/in/sukruthi-rao-923627313",
    "gmail": "sukruthirao03@gmail.com"
  },
  {
    id: 45,
    type: 'web_development_board',
    src: '/photos/members/IMG_20241027_175927[1].jpg',
    name: 'Aditya Shekhar',
    post: 'CHAIRPERSON',
    linkedin: 'https://www.linkedin.com/in/aditya-shekhar-662a55311/',
    gmail: 'adityashekhar0009@gmail.com',
  },
  {
    "id": 43,
    "type": "web_development_board",
    "src": "/photos/members25-26/RajathRP.jpg",
    "name": "Rajath R Prasad",
    "post": "CO-ORDINATOR",
    "linkedin": "https://www.linkedin.com/in/rajath-r-prasad",
    "gmail": "rajath2010rrp@gmail.com"
  },
  {
    id: 43,
    type: 'web_development_board',
    src: '/photos/members25-26/Manasa.jpeg',
    name: 'Manasa H N',
    post: 'CO-ORDINATOR',
    linkedin: 'https://www.linkedin.com/in/manasa-h-n-0383bb331',
    gmail: 'manasa14102004@gmail.com',
  },

];
export const team24_25 = [
  {
    id: 1,
    type: 'executive_committee',
    src: '/photos/members/K Vineeth Rao.PNG',
    name: 'K Vineeth Rao',
    post: 'CHAIRPERSON',
    linkedin: 'https://www.linkedin.com/in/vineeth-rao-kuthnikar-bb1109284',
    gmail: 'vineethk.rao@gmail.com',
  },
  {
    id: 2,
    type: 'executive_committee',
    src: '/photos/members/Manish_Bhargav.jpg',
    name: 'Manish Bhargav',
    post: 'VICE CHAIRPERSON',
    linkedin: 'https://linkedin.com/in/manish-bhargav-42a827297',
    gmail: 'manishbhargav1014@ieee.org ',
  },
  {
    id: 3,
    type: 'executive_committee',
    src: '/photos/members/Chaithanya P.jpg',
    name: 'Chaithanya P',
    post: 'GENERAL SECERETARY',
    linkedin: 'https://www.linkedin.com/in/chaithanya-p-58b718296',
    gmail: 'chaithanyap04@gmail.com',
  },
  {
    id: 4,
    type: 'executive_committee',
    src: '/photos/members/Rachana.jpg',
    name: 'Rachana K R',
    post: 'PUBLICITY LEAD',
    linkedin: 'https://www.linkedin.com/in/rachana-k-r-15a79825b',
    gmail: 'rachanaravi193@gmail.com',
  },
  {
    id: 5,
    type: 'executive_committee',
    src: '/photos/members/ABDULRAHIMAN CHOUDHARI.jpg',
    name: 'Abdulrahiman Choudhari',
    post: 'SAC COORDINATOR',
    linkedin: 'https://bit.ly/Linkedin_Abdulrahiman',
    gmail: 'abdulrahimankc123@gmail.com',
  },
  {
    id: 6,
    type: 'executive_committee',
    src: '/photos/members/P Pradeep Aradhya.jpg',
    name: 'P Pradeep Aradhya',
    post: 'SAC COORDINATOR',
    linkedin:
      'https://www.linkedin.com/in/pradeep-aradhya-1b1935287?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'pradeeparadhya739@gmail.com',
  },
  {
    id: 7,
    type: 'executive_committee',
    src: '/photos/members/Sonali shiladhar wali.jpg',
    name: 'Sonali Shiladhar Wali',
    post: 'EVENT MANAGER',
    linkedin: 'https://www.linkedin.com/in/sonali-shiladhar-wali-226621279',
    gmail: 'sonaliwali962004@gmail.com',
  },

  {
    id: 8,
    type: 'executive_committee',
    src: '/photos/members/Pushpa N B .jpg',
    name: 'Pushpa N B',
    post: 'REPORTING LEAD',
    linkedin:
      'https://www.linkedin.com/in/pushpa-n-b-13490b278?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'pushpanb246@gmail.com',
  },
  {
    id: 9,
    type: 'MEMBERSHIP DEVELOPMENT COMMITTEE',
    src: '/photos/members/Prashamsa.jpg',
    name: 'I Prashamsa Prabhu',
    post: 'SBMDC CHAIRPERSON',
    linkedin: 'https://www.linkedin.com/in/i-prashamsa-prabhu-a335b2290/',
    gmail: 'iprashamsaprabhu@gmail.com',
  },
  {
    id: 10,
    type: 'MEMBERSHIP DEVELOPMENT COMMITTEE',
    src: '/photos/members/harshi 1.jpeg',
    name: 'M S Harshitha',
    post: 'SBMDC VICE CHAIRPERSON',
    linkedin: 'https://www.linkedin.com/in/m-s-harshitha-657306294',
    gmail: 'harshitha8712@gmail.com',
  },
  {
    id: 12,
    type: 'executive_committee',
    src: '/photos/members/IMG-20241215-WA0001 - Pranav Vasishta G.jpg',
    name: 'Pranav Vasishta G',
    post: 'JOINT SECRETARY',
    linkedin: '',
    gmail: 'pranav2013g@gmail.com',
  },
  {
    id: 13,
    type: 'executive_committee',
    src: '/photos/members/IMG-20250102-WA0007~2 - Kiran Ramdurg.jpg',
    name: 'Kiran Ramdurg ',
    post: 'TREASURE',
    linkedin:
      'https://www.linkedin.com/in/kiran-ramdurg-85306617a',
    gmail: 'kiranramdurg17@gmail.com',
  },
  {
    id: 14,
    type: 'executive_committee',
    src: '/photos/members/WhatsApp Image 2025-03-26 at 20.45.18_b037c593.jpg',
    name: 'Chethana J ',
    post: 'CHEIF STUDENT COORDINATOR',
    linkedin: 'https://www.linkedin.com/in/chethana-j-14889825a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'chethanaj05@gmail.com',
  },
  {
    id: 15,
    type: 'executive_committee',
    src: '/photos/members/IMG-20250103-WA0013 - Charan S.jpg',
    name: 'Charan S',
    post: 'PUBLITY COORDINATOR',
    linkedin:
      'https://www.linkedin.com/in/charan-s-391640256/',
    gmail: 'cs8539929@gmail.com',
  },
  {
    id: 16,
    type: 'executive_committee',
    src: '',
    name: 'Suraj',
    post: 'STUDENT COORDINATOR',
    linkedin:
      '',
    gmail: '',
  },
  {
    id: 17,
    type: 'executive_committee',
    src: '/photos/members/IMG_0846_-_Kushwanth_S.jpg',
    name: 'Kushwanth S',
    post: 'STUDENT COORDINATOR',
    linkedin:
      'http://linkedin.com/in/kushwanth-s-profile',
    gmail: 'kushwanthsuresh8@gmail.com',
  },
  {
    id: 18,
    type: 'executive_committee',
    src: '/photos/members/IMG_6970 - Ananya Ramesha.jpeg',
    name: 'Ananya R',
    post: 'REPORTING TEAM',
    linkedin: 'http://linkedin.com/in/ananya-r-1591b9312',
    gmail: 'ananyaramesh054@gmail.com',
  },
  {
    id: 19,
    type: 'executive_committee',
    src: '/photos/members/IMG_20230618_172711_035 - Meghana K S.jpg',
    name: 'Yashaswini K S',
    post: 'REPORTING TEAM',
    linkedin: '',
    gmail: 'yashaswini.ks32@gmail.com',
  },
  {
    id: 20,
    type: 'MEMBERSHIP DEVELOPMENT COMMITTEE',
    src: '/photos/members/WhatsApp Image 2025-03-24 at 16.30.21_7c4fb8b1 - Sushanth Doggalli O.jpg',
    name: 'Sushanth Doggalli O',
    post: 'SECRETARY',
    linkedin: 'https://www.linkedin.com/in/sushanth-d-o-2a0980309?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'sushanthdoggalli@gmail.com',
  },
  {
    id: 21,
    type: 'MEMBERSHIP DEVELOPMENT COMMITTEE',
    src: '/photos/members/IMG20241019150840 - Chintan Shanbhog.jpg',
    name: 'Chintan C Shanbhog ',
    post: 'AMBASSADOR',
    linkedin: 'https://www.linkedin.com/in/chintan-c-shanbhog-3bb95b309?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'chintanshanbhog07@gmail.com',
  },
  {
    id: 22,
    type: 'Electron Devices Society',
    src: '/photos/members/Pranav Shandilya.jpg',
    name: 'Pranav Shandilya',
    post: 'CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/pranavshan19?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'shandilyapranav94@gmail.com',
  },
  {
    id: 23,
    type: 'Electron Devices Society',
    src: '/photos/members/vallish s (2).jpg',
    name: 'Vallish S',
    post: 'VICE CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/vallish-s-31491a23a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'vallishs52003@gmail.com',
  },
  {
    id: 24,
    type: 'Electron Devices Society',
    src: '/photos/members/Priyanshu Raj.jpg',
    name: 'Priyanshu Raj',
    post: 'SENIOR TECHNICAL CO-ORDINATOR',
    linkedin:
      'https://www.linkedin.com/in/priyanshu-raj-b558a522a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'priyanshuraj5510@gmail.com',
  },
  {
    id: 25,
    type: 'Electron Devices Society',
    src: '/photos/members/IMG_20250324_180440 - Gagan Deep.jpg',
    name: 'Gagan Deep P S',
    post: 'SECRETARY',
    linkedin:'https://www.linkedin.com/in/gagan-deep-71826a261?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'psgagan361@gmail.com',
  },
  {
    id: 26,
    type: 'Electron Devices Society',
    src: '/photos/members/IMG-20250324-WA0013 - Supreeth Prasad.jpg',
    name: 'Supreeth Prasad',
    post: 'JOINT SECRETARY',
    linkedin:
      'https://www.linkedin.com/in/supreeth-prasad-sp-51955a285?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'supreethp90@gmail.com',
  },
  {
    id: 27,
    type: 'Electron Devices Society',
    src: '/photos/members/Breakthrough chllng pic - Lumbini Ashutosh Tambat.png',
    name: 'Lumbini A Tambat',
    post: 'TECHNICAL CO-ORDINATOR',
    linkedin:
      'https://www.linkedin.com/in/lumbini-ashutosh-tambat-a83878309/',
    gmail: 'lumbiniatambat@gmail.com',
  },
  {
    id: 28,
    type: 'women in engineering',
    src: '/photos/members/IMG_20241224_210925 - Sinchana Yashodhar.jpg',
    name: 'Sinchana Y',
    post: 'CHAIRPERSON',
    linkedin: 'https://www.linkedin.com/in/sinchana-y-243811278?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'sinchany066@gmail.com',
  },
  {
    id: 29,
    type: 'women in engineering',
    src: '/photos/members/Vaibhav_Kammar.jpg',
    name: 'Vaibhav Kammar',
    post: 'VICE CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/vaibhav-kammar-b4ba86241?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'vaibhavkammar06@gmail.com,',
  },

  {
    id: 30,
    type: 'women in engineering',
    src: '/photos/members/Siri_J.jpg',
    name: 'Siri J',
    post: 'SENIOR TECHNICAL CO-ORDINATOR',
    linkedin:
      'https://www.linkedin.com/in/siri-j-0b250b230?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'sirilj20062003@gmail.com',
  },
  {
    id: 31,
    type: 'women in engineering',
    src: '/photos/members/Mythri Manjunath.jpg',
    name: 'Mythri Manjunath',
    post: 'SENIOR EVENT CO-ORDINATOR',
    linkedin:
      'https://www.linkedin.com/in/mythri-manjunath-8b1a1a294?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app  ',
    gmail: 'mythrimanjunath2003@gmail.com',
  },
  {
    id: 32,
    type: 'women in engineering',
    src: '/photos/members/IMG_20250324_150759 - Lalithya Govardhan.jpg',
    name: 'Lalithya Govardhan',
    post: 'SECRETARY',
    linkedin: 'https://www.linkedin.com/in/lalithya-govardhan-a05363341?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'lalithyag0224@gmail.com',
  },
  {
    id: 33,
    type: 'women in engineering',
    src: '/photos/members/Bharath photo - Bharatheshwar M.jpeg',
    name: 'Bharatheshwar M',
    post: 'JOINT SECRETARY',
    linkedin:
      'http://www.linkedin.com/in/bharatheshwar-m-9323b9187',
    gmail: 'bharatheshwar31m@gmail.com',
  },
  {
    id: 34,
    type: 'women in engineering',
    src: '/photos/members/WhatsApp Image 2025-03-24 at 15.07.55_00514846 - Thanmayee A.jpg',
    name: 'Thanmayee A',
    post: 'TECHNICAL CO-ORDINATOR',
    linkedin:
      'http://www.linkedin.com/in/thanmayee1213',
    gmail: 'thanmayeea.13@gmail.com',
  },
  {
    id: 35,
    type: 'women in engineering',
    src: '',
    name: 'Pragathi P',
    post: 'EVENT CO-ORDINATOR',
    linkedin:
      '',
    gmail: '',
  },
  {
    id: 36,
    type: 'robotics and automation society',
    src: '/photos/members/Sudhanva N.Kulkarni.jpg',
    name: 'Sudhanva N Kulkarni',
    post: 'CHAIRPERSON',
    linkedin: 'https://www.linkedin.com/in/sudhanva-kulkarni-a922bb220',
    gmail: 'ksudhanva03@gmail.com',
  },
  {
    id: 37,
    type: 'robotics and automation society',
    src: '/photos/members/Amit_Verma.jpg',
    name: 'Amit Verma',
    post: 'VICE CHAIRPERSON',
    linkedin: 'https://www.linkedin.com/in/amit-verma-1b5677249/ ',
    gmail: 'amitverma5262.02@gmail.com',
  },
  {
    id: 38,
    type: 'robotics and automation society',
    src: '/photos/members/Rishabh raj.jpeg',
    name: 'Rishabh Raj',
    post: 'SENIOR TECHNICAL CO-ORDINATOR',
    linkedin: 'https://www.linkedin.com/in/rishabh-raj-468629297',
    gmail: 'rishabh1232326@gmail.com',
  },
  {
    id: 39,
    type: 'robotics and automation society',
    src: '/photos/members/IMG_20241225_114554 - Nandeesh.S.U.jpg',
    name: 'Nandeesh S U',
    post: 'SECRETARY',
    linkedin: 'https://www.linkedin.com/in/nandeesh-s-u?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'nandeeshsu2003@gmail.com',
  },
  {
    id: 40,
    type: 'robotics and automation society',
    src: '/photos/members/IMG_20250324_153735 - Adnan Hussain.jpg',
    name: 'Adnan Hussain Sarkar',
    post: 'JOINT SECRETARY',
    linkedin: 'https://www.linkedin.com/in/adnan-hussain-sarkar-4846b11bb',
    gmail: 'adnanhsarkar16@gmail.com',
  },
  {
    id: 41,
    type: 'robotics and automation society',
    src: '/photos/members/PXL_20250114_181346915 - Akshay.jpg',
    name: 'Akshay Kumar',
    post: 'TECHNICAL CO-ORDINATOR',
    linkedin: 'https://www.linkedin.com/in/akshay-kumar-9484592a1?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'akshayyk210@gmail.com',
  },
  {
    id: 42,
    type: 'web development board',
    src: '/photos/members/subroto.jpg',
    name: 'Subroto Koiry',
    post: 'CHAIRPERSON',
    linkedin: 'https://www.linkedin.com/in/subroto-koiry  ',
    gmail: 'koirysubroto1103@gmail.com',
  },
  {
    id: 43,
    type: 'web development board',
    src: '/photos/members/IMG_20241027_175927[1].jpg',
    name: 'Aditya Shekhar',
    post: 'CO-ORDINATOR',
    linkedin: 'https://www.linkedin.com/in/aditya-shekhar-662a55311/',
    gmail: 'adityashekhar0009@gmail.com',
  },
  {
    id: 44,
    type: 'editorial board',
    src: '/photos/members/Neethushree GN.PNG',
    name: 'Neethushree G N',
    post: 'CHAIRPERSON',
    linkedin: 'https://www.linkedin.com/in/neethu-shree-g-n-97a0a3255/',
    gmail: 'neethushreegn@gmail.com',
  },
  {
    id: 45,
    type: 'editorial board',
    src: '/photos/members/Shreekara Bhat.jpg',
    name: 'Shreekara Bhat',
    post: 'SENIOR EDITOR',
    linkedin:
      'https://www.linkedin.com/in/shreekara-bhat-309a35254?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'shreekarabhat04@gmail.com',
  },
  {
    id: 46,
    type: 'editorial board',
    src: '/photos/members/hetarth.png',
    name: 'Hetarth Jain',
    post: 'SENIOR EDITOR',
    linkedin:
      ' https://www.linkedin.com/in/hetarth-jain?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'hetarth.jain@gmail.com',
  },
  {
    id: 47,
    type: 'editorial board',
    src: '/photos/members/IMG_5835 - Skanda sai Keshav.jpeg',
    name: 'Keshav Skanda Sai',
    post: 'GRAPHIC DESIGNER',
    linkedin: 'https://www.linkedin.com/in/skanda-sai-keshav-814a35258/overlay/about-this-profile/?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base%3BqG2endZmSYKExvezg1mQdQ%3D%3D',
    gmail: 'niknis81@gmail.com',
  },

  {
    id: 48,
    type: 'editorial board',
    src: '/photos/members/website photo - Manya Basappa.jpg',
    name: 'Manya G Basappa',
    post: 'EDITOR',
    linkedin:
      'https://www.linkedin.com/in/manya-basappa-2920b6309?ut',
    gmail: 'manyagbasappa@gmail.com',
  },
  {
    id: 49,
    type: 'editorial board',
    src: '/photos/members/profile - Varadaraj g.jpg',
    name: 'Varadaraj G',
    post: 'EDITOR',
    linkedin:
      'http://www.linkedin.com/in/varadaraj-g-821b30257',
    gmail: 'varadarajug51@gmail.com',
  },
]

export const senior2022_team_photo = [
  {
    id: 1,
    type: 'executive_committee',
    src: '/photos/members/Chinmaya1.JPG',
    name: 'Chinmaya K',
    post: 'CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/chinmaya-k-2ab51221a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
    gmail: 'chinmayak77@gmail.com',
  },
  {
    id: 2,
    type: 'executive_committee',
    src: '/photos/members/Shivraj.JPG',
    name: 'Shivraj Nath',
    post: 'VICE CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/shivraj-nath-892244124?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: '18srjn@gmail.com',
  },
  {
    id: 3,
    type: 'executive_committee',
    src: '/photos/members/Surendra.jpg',
    name: 'Surendra R Hegde',
    post: 'GENERAL SECRETARY',
    linkedin: 'https://www.linkedin.com/in/surendra-hegde-9b9042106',
    gmail: 'surendrahegde3@gmail.com',
  },
  {
    id: 4,
    type: 'executive_committee',
    src: '/photos/members/Ankit.jpg',
    name: 'Ankit Priyesh ',
    post: 'SAC CO-ORDINATOR',
    linkedin:
      'https://www.linkedin.com/in/ankit-priyesh-101505247?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'priyesh.ankit3@gmail.com',
  },
  {
    id: 5,
    type: 'executive_committee',
    src: '/photos/members/AMRUTHA.png',
    name: 'Amrutha K R',
    post: 'SAC CO-ORDINATOR',
    linkedin:
      'https://www.linkedin.com/in/amrutha-k-r-6315aa1b6?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'amruthaputti01@gmail.com',
  },
  {
    id: 6,
    type: 'executive_committee',
    src: '/photos/members/Mandara.jpg',
    name: 'Mandara Shivakumar',
    post: 'EVENT MANAGER',
    linkedin:
      'https://www.linkedin.com/in/mandara-shivakumar-a848171b0?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'mandarashivakumar@gmail.com',
  },
  {
    id: 7,
    type: 'executive_committee',
    src: '/photos/members/Sparshi.jpg',
    name: 'Sparshi Agrawal',
    post: 'REPORTING LEAD',
    linkedin:
      'https://www.linkedin.com/in/sparshi-agrawal-28ba87218?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'sparshi.agrawal091@gmail.com',
  },
  {
    id: 8,
    type: 'executive_committee',
    src: '/photos/members/Hamsini.jpg',
    name: 'Hamsini V',
    post: 'PUBLICITY LEAD',
    linkedin:
      'https://www.linkedin.com/in/hamsini-v-37495221a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'hamsinisvm@gmail.com',
  },
  {
    id: 9,
    type: 'executive_committee',
    src: '/photos/members/IMG_20230617_122843_Bokeh.jpg',
    name: 'C A Akhil',
    post: 'JOINT SECRETARY',
    linkedin: 'https://www.linkedin.com/in/akhil-c-a-642606246',
    gmail: 'akhilca232002@gmail.com',
  },
  {
    id: 10,
    type: 'executive_committee',
    src: '/photos/members/Prajwal.jpg',
    name: 'Prajwal K',
    post: 'TREASURER',
    linkedin:
      'https://www.linkedin.com/in/prajwal2727?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
    gmail: 'prajwalrao123@gmail.com',
  },
  {
    id: 11,
    type: 'executive_committee',
    src: '/photos/members/Sneha N Angadi.jpg',
    name: 'Sneha N Angadi',
    post: 'CHIEF STUDENT CO-ORDINATOR',
    linkedin: 'https://www.linkedin.com/in/chaithanya-p-58b718296',
    gmail: '',
  },
  {
    id: 12,
    type: 'executive_committee',
    src: '/photos/members/K Ganapathi sharma.jpg',
    name: 'K Ganpathi Sharma',
    post: 'STUDENT CO-ORDINATOR',
    linkedin: 'www.linkedin.com/in/ganapathi-sharma',
    gmail: 'ganapathisharma2003@gmail.com',
  },
  {
    id: 13,
    type: 'executive_committee',
    src: '/photos/members/Sriharihara Kashyap.S.jpg',
    name: 'Sriharihara Kashyap S',
    post: 'STUDENT CO-ORDINATOR',
    linkedin: '',
    gmail: '',
  },
  {
    id: 14,
    type: 'executive_committee',
    src: '/photos/members/Sohan S.jpg',
    name: 'Sohan S',
    post: 'PUBLICITY CO-ORDINATOR',
    linkedin: 'https://bit.ly/Linkedin_Abdulrahiman',
    gmail: 'sohansnair1563717@gmail.com',
  },
  {
    id: 15,
    type: 'executive_committee',
    src: '/photos/members/Meghana.jpg',
    name: 'Meghana',
    post: 'REPORTING TEAM',
    linkedin:
      's://www.linkedin.com/in/meghana-ballal-735314212?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'meghanaballal02@gmail.com',
  },
  {
    id: 16,
    type: 'executive_committee',
    src: '/photos/members/Deeksha Hegde.PNG',
    name: 'Deeksha Hegde',
    post: 'REPORTING TEAM',
    linkedin:
      'https://www.linkedin.com/in/deeksha-hegde-890407210?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
    gmail: 'deekshahegde321@gmail.com',
  },
  {
    id: 17,
    type: 'MEMBERSHIP DEVELOPMENT COMMITTEE',
    src: '/photos/members/Suyash.jpg',
    name: 'Suyash G Patil',
    post: 'CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/shonigp?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'suyash.g.patil@gmail.com',
  },
  {
    id: 18,
    type: 'MEMBERSHIP DEVELOPMENT COMMITTEE',
    src: '/photos/members/AMRUTHA.png',
    name: 'Amrutha K R',
    post: 'VICE CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/amrutha-k-r-6315aa1b6?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'amruthaputti01@gmail.com',
  },
  {
    id: 19,
    type: 'MEMBERSHIP DEVELOPMENT COMMITTEE',
    src: '/photos/members/Prakruthi K P .jpg',
    name: 'Prakruti K P',
    post: 'SECRETARY',
    linkedin:
      'https://www.linkedin.com/in/prakruthi-k-p-787313212?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'prakruthikp17@gmail.com',
  },
  {
    id: 20,
    type: 'MEMBERSHIP DEVELOPMENT COMMITTEE',
    src: '/photos/members/Sumukh J Kowligi.jpg',
    name: 'Sumukh J Kowligi',
    post: 'AMBASSADOR',
    linkedin:
      'https://www.linkedin.com/in/sumukhkowligi?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'sumukhkowligi@gmail.com',
  },
  {
    id: 21,
    type: 'Electron Devices Society',
    name: 'Mukul',
    src: '/photos/members/Mukul1.jpg',
    post: 'CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/mukul-pathak-a367a61b3?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'mukulkr21799@gmail.com',
  },
  {
    id: 22,
    type: 'Electron Devices Society',
    name: 'Sushma B S',
    src: '/photos/members/Sushma1.jpeg',
    post: 'VICE CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/sushma-bs?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'sushma.bananda@gmail.com',
  },
  {
    id: 23,
    type: 'Electron Devices Society',
    src: '/photos/members/Abdullah Meeran MH.jpg',
    name: 'Abdullah Meeran M H',
    post: 'SECRETARY',
    linkedin: 'https://www.linkedin.com/in/abdullah-meeran-mh-31a913236',
    gmail: 'abdullahmeeran18@gmail.com ',
  },
  {
    id: 24,
    type: 'Electron Devices Society',
    src: '/photos/members/P A Anshad.jpg',
    name: 'P A Anshad',
    post: 'JOINT SECRETARY',
    linkedin: 'https://www.linkedin.com/in/anshad-p-a-66329a213/',
    gmail: 'anshadpa720@gmail.com',
  },
  {
    id: 25,
    type: 'Electron Devices Society',
    src: '/photos/members/Ashwin V Bhandari.JPG',
    name: 'Ashwin Vijayakumar Bhandari',
    post: 'TECHNICAL CO-ORDINATOR',
    linkedin: 'https://www.linkedin.com/in/ashwin-bhandari396/',
    gmail: 'ashwinvbhandari@gmail.com',
  },
  {
    id: 26,
    type: 'women in engineering',
    src: '/photos/members/Saswathi.jpeg',
    name: 'D Saswathi Srichhakri',
    post: 'CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/d-saswathi-srichakri-07b772245?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'saswathi.chakri@gmail.com',
  },
  {
    id: 27,
    type: 'women in engineering',
    src: '/photos/members/Vanditha.jpg',
    name: 'Vanditha M',
    post: 'VICE CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/vanditha07?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'mvanditha07@gmail.com',
  },
  {
    id: 28,
    type: 'women in engineering',
    src: '/photos/members/Sudhanva.jpeg',
    name: 'Sudhanva R',
    post: 'SENIOR EVENT CO-ORDINATOR',
    linkedin:
      'https://www.linkedin.com/in/sudhanva-ramesh-678505214?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'sudhanvar2001@gmail.com ',
  },
  {
    id: 29,
    type: 'women in engineering',
    src: '/photos/members/Smrithi Bhat.jpg',
    name: 'Smrithi Bhat',
    post: 'SECRETARY',
    linkedin: 'https://www.linkedin.com/in/smrithi-bhat-139313212/ ',
    gmail: 'smrithib0602@gmail.com',
  },
  {
    id: 30,
    type: 'women in engineering',
    src: '/photos/members/IMG_9439.JPG',
    name: 'Umar Ahmed',
    post: 'JOINT SECRETARY',
    linkedin: 'https://www.linkedin.com/in/umar-ahmad-7a0b73245 ',
    gmail: 'umarahmad10786@gmail.com',
  },

  {
    id: 31,
    type: 'women in engineering',
    src: '/photos/members/neha_tg.jpg',
    name: 'Neha T G',
    post: 'Senior Technical Coordinator',
    linkedin: 'https://www.linkedin.com/in/neha-t-g-832340231',
    gmail: 'nehatg504@gmail.com',
  },
  {
    id: 32,
    type: 'women in engineering',
    src: '/photos/members/Ananya A.jpg',
    name: 'Ananya A',
    post: 'EVENT CO-ORDINATOR',
    linkedin: 'https://www.linkedin.com/in/ananyaa21',
    gmail: 'ananyaachendu21@gmail.com',
  },
  {
    id: 33,
    type: 'robotics and automation society',
    src: '/photos/members/Raghavendra.jpg',
    name: 'Raghavendra G',
    post: 'CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/raghavendra-g-b0406a1b7?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'raghavendra422001@gmail.com',
  },
  {
    id: 34,
    type: 'robotics and automation society',
    src: '/photos/members/Snehith.jpg',
    name: 'Snehith K',
    post: 'VICE CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/snehith-k-9b3158218?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: '',
  },
  {
    id: 35,
    type: 'robotics and automation society',
    src: '/photos/members/HARSHITH1.jpg',
    name: 'R Harshith',
    post: 'SENIOR TECHNICAL CO-ORDINATOR',
    linkedin:
      'https://www.linkedin.com/in/r-harshith-313211192?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'rharshith2697@gmail.com',
  },
  {
    id: 36,
    type: 'robotics and automation society',
    src: '/photos/members/Gururaj Deepak Todurkar .jpeg',
    name: 'Gururaj Deepak Todurkar',
    post: 'SECRETARY',
    linkedin: 'https://www.linkedin.com/in/gururaj-todurkar-b0579a240',
    gmail: 'gururajdtodurkar7@gmail.com',
  },
  {
    id: 37,
    type: 'robotics and automation society',
    src: '/photos/members/krishnakumar.jpg',
    name: 'Krishnakumar Balachandra Bhat',
    post: 'JOINT SECRETARY',
    linkedin: 'https://www.linkedin.com/in/20181729/',
    gmail: 'krishnakumarbhat02@gmail.com',
  },
  {
    id: 38,
    type: 'robotics and automation society',
    src: '/photos/members/Darshan D Kerkar .jpg',
    name: 'Darshan D Kerkar',
    post: 'TECHNICAL CO-ORDINATOR',
    linkedin: 'https://www.linkedin.com/in/darshan-kerkar-94a26427a',
    gmail: 'darshankerkar04@gmail.com',
  },
  {
    id: 39,
    type: 'web development board',
    src: '/photos/members/Shomik.jpg',
    name: 'Shomik Ghosh',
    post: 'CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/shomik-ghosh-01016a190?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'shomikghosh2020@gmail.com',
  },
  {
    id: 40,
    type: 'web development board',
    src: '/photos/members/IMG20210307144705 1.jpg',
    name: 'Debojyoti Koley',
    post: 'CO-ORDINATOR',
    linkedin: 'https://www.linkedin.com/in/debojyoti-koley-2268071a8/',
    gmail: 'debojyoti.koley.dk@gmail.com',
  },
  {
    id: 41,
    type: 'editorial board',
    src: '/photos/members/Shukla.JPG',
    name: 'P Shukla',
    post: 'CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/p-shukla-1010s1010?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'shuklaparthasarathy@gmail.com',
  },
  {
    id: 42,
    type: 'editorial board',
    src: '/photos/members/RASHMI.jpg',
    name: 'RASHMI R',
    post: 'VICE CHAIRPERSON',
    linkedin:
      'https://www.linkedin.com/in/rashmi-r-ab494a235?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'rashmirahul21@gmail.com',
  },
  {
    id: 43,
    type: 'editorial board',
    src: '/photos/members/hardik.jpg',
    name: 'Hardik Shettigar',
    post: 'SENIOR EDITOR',
    linkedin:
      'https://www.linkedin.com/in/hardik-shettigar-b7085218a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'hardikhard28@gmail.com',
  },
  {
    id: 44,
    type: 'editorial board',
    src: '/photos/members/Chandana.jpg',
    name: 'Chandana Raju',
    post: 'SENIOR EDITOR',
    linkedin:
      'https://www.linkedin.com/in/chandana-raju?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    gmail: 'chandanaraje1503@gmail.com',
  },
  {
    id: 45,
    type: 'editorial board',
    src: '/photos/members/IMG20220908082302 (2).jpg',
    name: 'Pushpesh Joshi',
    post: 'GRAPHIC DESIGNER',
    linkedin: 'https://www.linkedin.com/in/pushpesh-joshi-5493101b8',
    gmail: 'joshi.pushpesh09@gmail.com',
  },
  {
    id: 46,
    type: 'editorial board',
    src: '/photos/members/Priyanshu  Tripathi .jpg',
    name: 'Priyanshu Kumar Tripathi',
    post: 'GRAPHIC DESIGNER',
    linkedin: 'https://www.linkedin.com/in/priyanshu-kr-tripathi-4658a822a',
    gmail: 'vashu.tripathi23@gmail.com',
  },
  {
    id: 47,
    type: 'editorial board',
    src: '/photos/members/Vindya K.jpg',
    name: 'Vindya K',
    post: 'EDITOR',
    linkedin: 'https://www.linkedin.com/in/vindya-k/',
    gmail: 'kvindya404@gmail.com',
  },
  {
    id: 48,
    type: 'editorial board',
    src: '/photos/members/IMG-20231028-WA0076.jpg',
    name: 'Adya S',
    post: 'EDITOR ',
    linkedin: 'https://www.linkedin.com/in/adya-sujeet-168288254  ',
    gmail: 'adyasujeet@yahoo.com',
  },
]  